import React from 'react'
import { LoadingSpinner } from './LoadingSpinner'

/**
 * Spinner de espera por cima da tela, com o fundo escurecido.
 *
 * Diferente do `LoadingSpinner` sozinho, que as listagens usam para substituir a pagina inteira
 * enquanto ela nunca foi montada. Este serve para a espera de uma **acao que nao pode ser
 * interrompida** com a tela ja montada — estornar um lancamento — em que a pagina precisa continuar
 * la atras, mas intocavel.
 *
 * Para a espera de uma consulta (paginar, ordenar, filtrar, voltar do formulario) o certo e o
 * `ContentLoadingOverlay`, que vela so a grade e deixa o menu e a toolbar clicaveis.
 *
 * Reusa o que o projeto ja tem, sem CSS novo: o proprio `LoadingSpinner` (mesmo desenho de spinner
 * do resto do sistema) e a classe `p-component-overlay` do tema, que e a mesma mascara que os
 * dialogos usam para escurecer o fundo.
 *
 * Alem de avisar, ele **bloqueia clique** no resto da tela durante a espera. O `LoadingSpinner` se
 * posiciona em z-index 9999, entao a mascara fica em 9998 para ficar por baixo dele.
 */
export const LoadingOverlay = () => (
  <div
    className="p-component-overlay"
    style={{
      position: 'fixed',
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      zIndex: '9998',
    }}
  >
    <LoadingSpinner />
  </div>
)
